import { Select } from '@stratascratch/ui'
import CODE_TYPES from '@stratascratch/code-editor/dist/consts'
import { CodeType } from '@stratascratch/code-editor'

interface Props {
  codeType: CodeType
  codeTypeOptions: CodeType[]
  onChange: (codeType: CodeType) => void
  tables: string[] | null | undefined
}

function EditorCaptionBar({
  codeType,
  codeTypeOptions,
  onChange,
  tables,
}: Props) {
  const options = codeTypeOptions.map((c) => ({
    value: c,
    label: CODE_TYPES[c].label,
  }))

  return (
    <div className="bg-(--bg-color-secondary) text-(--text-color-300) flex items-center justify-between px-4 py-2 [&_.Select\_\_control]:!bg-white">
      {codeTypeOptions.length > 1 ? (
        <Select
          name="language"
          value={options.find((opt) => opt.value === codeType)}
          onChange={(opt) => {
            if (opt) onChange(opt.value)
          }}
          options={options}
          isSearchable={false}
        />
      ) : (
        <span>{CODE_TYPES[codeType].label}</span>
      )}
      {tables && (
        <span className="bg-(--bg-color-primary) rounded-full px-3 py-1 text-sm">
          <span className="font-bold">Tables: </span>
          {tables.join(', ')}
        </span>
      )}
    </div>
  )
}

export default EditorCaptionBar
